import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, TextField, Autocomplete, CircularProgress, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import { Row , Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './payroll.css'
import ButtonTheme from "../../components/ThemeButton/ThemeButton";

const PersonalPayroll = () => {
	const { user, permission, pages, v3Data } = useContext(AuthContext)
	const [loading, setLoading] = useState(false);
	const [payrollList, setPayrollList] = useState([]);
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);
	const [activeTab , setActiveTab] = useState('personal-payroll');
	const navigate = useNavigate();
	const [selectedRow, setSelectedRow] = useState([]);
	const [buttonLoading , setButtonLoading] = useState(false);

	const columns = [
		{
			field: 'name', headerName: 'Name', flex: 1, minWidth: 150,
			valueGetter: (params) => { return (params?.row?.employee?.fullName) }
		},

		{
			field: 'Month', headerName: 'Approval Month', flex: 1, minWidth: 160, valueGetter: (params) => params?.row?.approval_month_formatted
		},

		{
			field: 'status', headerName: 'Status', flex: 1, minWidth: 130,
			renderCell: (params) => {
				return (
					<Chip style={{ width: '100% !important' }}
						label={ (params?.row?.is_admin_override === true) ? ("Approved By Admin") : (params?.row?.Status?.charAt(0).toUpperCase() + params?.row?.Status?.slice(1))}
						className={'status-chip'} />)
			}
		},

		{
			field: 'time1', headerName: 'Acknowledged At', flex: 1, minWidth: 160,
			renderCell: (params) => {
				return   (params?.row?.Approved_At ? (moment(params?.row?.Approved_At).format("DD MMM YYYY") + ' ' + varFormatTime(timeFormat(moment(params?.row?.Approved_At).format("HH:mm:ss")), user?.Time_Format)) : (moment(params?.row?.Create_Time).format("DD MMM YYYY") + ' ' + varFormatTime(timeFormat(moment(params?.row?.Create_Time).format("HH:mm:ss")), user?.Time_Format)))
			}
		},

	...(v3Data?.V3_CAN_ADMIN_OVERRIDE_TIMECARD_APPROVAL
		? [
			{
			field: 'approve',
			headerName: 'Approved By',
			flex: 1,
			minWidth: 200,
			valueGetter: (params) => params?.row?.approved_by?.fullName
			}
		]
		: []),

		...((!v3Data?.V3_EXPORT_PAYROLL_REPORT_AS_CSV || v3Data?.V3_EXPORT_PAYROLL_REPORT_AS_CSV === 'false')
		? [
			{
				field: 'report', headerName: 'View Report', flex: 1, minWidth: 80,  maxWidth: 110,
				renderCell: (params) => (
					<a target="blank" href={params?.row?.Pdf_Url}>
						<div>
							<img src='/images/cloud.png' width={20} height={20} />
						</div>
					</a>
				)
			},
		] : []),
		...(v3Data?.V3_EXPORT_PAYROLL_REPORT_AS_CSV ?
		[
			{
				field: 'button', headerName: 'Export', flex: 1, minWidth: 260,
				renderCell: (params) => (
					<>
						{(buttonLoading && selectedRow?.Emp_Code == params?.row?.Emp_Code) ? 
							<ButtonTheme
								color="primary"
							>
								<div style={{display:'flex' , alignItems:'center' , justifyContent:'center'}}>
									<div className="d-flex justify-content-center align-items-center font-fam" style={{color:'#ffffff' , fontSize:'12px'}}>
										<CircularProgress 
											sx={{
												marginRight:'10px',
												width:'20px !important',
												height:'20px !important',
												color:'#ffffff'
											}}
										/>
									</div>
									<span>Export CSV</span>
								</div>
							</ButtonTheme>
							:
							<ButtonTheme
								color="primary"
								onClick={() => {
									exportCSV(params?.row)
									setSelectedRow(params?.row)
								}}
							>
								<div>
									Export CSV
								</div>
							</ButtonTheme>
						}
			
						<ButtonTheme
							color="primary"
							className='mx-2'
							onClick={() => exportPDF(params?.row)}
						>
							Export PDF
						</ButtonTheme>
					</>
				)
			},
		] : [])
	]

	const getPayrollList = (loader = true) => {
		if (loader) {
			setLoading(true);
		}
		ApiService.get(permission.includes('global_admin') ? "/payroll/all-payroll-report" : "/payroll/get-payroll-report")
			.then(({ data }) => {
				var tempArr = []
				data.data.map((Id) => {
					var obj = Id
					obj.id = Id.Id
					tempArr.push(obj)
				})
				setPayrollList(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getPayrollList()
	}, [])

	const exportCSV = (emp) => {
		if (!emp?.Period_Start_Date || !emp?.Period_End_Date || !emp?.Emp_Code) return;
		let data = {
			"start_date" : emp?.Period_Start_Date,
			"end_date" : emp?.Period_End_Date,
			"emp_code" : emp?.Emp_Code,
		}
		setButtonLoading(true);
		ApiService.post("/payroll/export-csv", data)
			.then((data) => {
				const url = window.URL.createObjectURL(
					new Blob([data], { type: "text/csv" })
				);

				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "personal-payroll_export.csv");
				document.body.appendChild(link);
				link.click();

				link.remove();
				window.URL.revokeObjectURL(url);
				setButtonLoading(null);
			})
			.catch(( err ) => {
				toast.error(err.data.message || err.message || 'error')
				console.log(err.data.message)
			});
	};

	const exportPDF = (emp) => {
		if (!emp?.Pdf_Url) {
			toast.error("PDF URL not found");
			return;
		}
		window.open(emp.Pdf_Url, "_blank");
	};


	return (
		<>
			{loading ? (
				<>
					<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
						<CircularProgress />
					</Paper></>
			) :
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
							<Grid container spacing={2} className='align-items-center'>

								{/* Heading */}
								<Row style={{paddingLeft:'24px' , paddingTop:'24px'}}>
									<Col style={{paddingRight:'0px' , paddingLeft:'0px' , flex:'0.1' , marginBottom:'10px'}}>
										<div
											style={{ width: '190px' }}
											className={activeTab === 'personal-payroll' ? 'tab-active mx-1' : 'tab-white mx-1'}
											onClick={() => {
												setActiveTab('personal-payroll')
												navigate('/firehouse/personal-payroll-list')
											}}
											>
											Personal Payroll
										</div>
									</Col>
					
									<Col style={{paddingRight:'0px' , paddingLeft:'0px' , flex:'0.1' , marginBottom:'10px'}}>
										<div
											style={{ width: '210px' }}
											className={activeTab === 'acknowledge-payroll' ? 'tab-active mx-1' : 'tab-white mx-1'}
											onClick={() => {
												setActiveTab('acknowledge-payroll')
												navigate('/firehouse/personal-payroll-report')
											}}
											>
											Acknowledge Payroll 
										</div>
									</Col>
								</Row>
							</Grid>

							{(!payrollList || payrollList.length == 0) ?
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565 }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Payroll Found
									</span>
								</div>
								:
								<>
									<div className='mt-4'>
										<DataGrid
											rows={payrollList}
											columns={columns}
											checkboxSelection={false}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>
									</div>
								</>
							}
						</Paper>
					</>
				)
			}
		</>
	)
}

export default PersonalPayroll